<template>
  <div class="product-mask" v-if="isShow">
    <div class="mask-contain">
      <div class="mask-tip">即将跳转的页面由第三方平台提供并由其依法承担相应的责任。如遇问题，建议您与相应平台联系沟通，与本平台无关。</div>
      <div class="mask-progress-box">
        <div class="mask-progress"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less">
.product-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .55);

  .mask-contain {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: calc(100% - .7rem);
    font-size: .24rem;
    color: #fff;
  }

  .mask-tip {
    text-align: center;
  }

  .mask-progress-box {
    width: 3.74rem;
    height: 0.2rem;
    background: #f1f3f8;
    border-radius: 0.12rem;
    padding: 0.04rem;
    box-sizing: border-box;
    margin: 0.48rem auto;
  }

  .mask-progress {
    height: 100%;
    background: linear-gradient(90deg, #78f7ff, #0044ff);
    border-radius: 0.08rem;
    box-shadow: 0rem 0.04rem 0.04rem 0rem rgba(39, 91, 245, 0.10), 0rem 0.02rem 0.06rem 0rem rgba(255, 255, 255, 0.50) inset;
    animation: changewidth 3s ease-in-out;
  }

  @keyframes changewidth {
    0% {
      width: 0
    }

    50% {
      width: 50%
    }

    100% {
      width: 100%
    }
  }
}
</style>
